import styles from "./DropDown.module.css";
import arrow from "../../Images/Components/DDarrow.png"

// Define the props that the Input component will accept
interface InputProps {
    label: string;
    id: string;
    required?: boolean;
    options: { value: string; label: string }[];
    onChange?: (value: string) => void;
    name: string;
}

const DropDown: React.FC<InputProps> = ({ label, id, required, options, onChange, name }) => {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        console.log("Selected value:", value);
        if (onChange) onChange(value); // 👈 Notify parent
    };
    return (
        <div className={styles.dropDownContainer}>
            <label htmlFor={id} className={`${styles.inputLabel} ${styles.reasonLabel}`}>
                {label}{required && '*'}
            </label>
            <div style={{ position: 'relative' }}>
                <select
                    id={id}
                    className={styles.reasonSelect}
                    required={required}
                    name={name}
                    onChange={handleChange}
                    defaultValue="" // Use defaultValue instead of selected on option
                >
                    <option value="" disabled hidden>
                        Select Option
                    </option>
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <div className={styles.selectArrow} aria-hidden="true">
                    <img className={styles.arrow} src={arrow} />
                </div>
            </div>
        </div>
    );
};

export default DropDown;